import React from "react";
import '../../campaigns.css';
import { notifyStationsIcon } from "assets";
import useStore from "components/campaigns/hooks/useCampaignStore";
import { getCampaignMarketsNotification } from "components/campaigns/requests";
import { OpDataGrid } from "op2mise-react-widgets";
import Button from "shared/components/button/Button";
import ComposeEmailForm from "./ComposeEmailForm";
import NotifyAllMarketsModal from "./NotifyAllMarketsModal";
import NotifySelectedMarketModal from "./NotifySelectedMarketModal";
import SuccessfullyNotifiedModal from "./SuccessfullyNotifiedModal";
import BootstrapSpinner from "shared/components/bootstrap-spinner/BootstrapSpinner";

const NotificationsForm = ({  }) => {
    const {
        isCampaignActive,
        selectedCampaign,
        setNewCampaign,
        setShowCampaignForms,
        newCampaign,
    } = useStore((state) => state);
    const [isFetchingMarkets, setIsFetchingMarkets] = React.useState(true);
    const [markets, setMarkets] = React.useState([]);
    const [selectedMarketId, setSelectedMarketId] = React.useState(null);
    const [selectedContacts, setSelectedContacts] = React.useState([]);
    const [showComposeEmailForm, setShowComposeEmailForm] = React.useState(false);
    const [showNotifyAllMarketsForm, setShowNotifyAllMarkets] = React.useState(false);
    const [showSuccessfullyNotifiedModal, setShowSuccessfullyNotifiedModal] = React.useState(false);

    const handleCloseForm = () => {
        setNewCampaign(false);
        setShowCampaignForms(false);
    };

    const handleGetMarkets = async () => {
        setIsFetchingMarkets(true);

        try {
            const res = await getCampaignMarketsNotification(selectedCampaign.id);
            setMarkets(res.marketDistributionListingResults);
        } catch(err) {
            console.error(err);
        } finally {
            setIsFetchingMarkets(false);
        }
    };

    const handleGetStations = async (event, params) => {
        if (!isCampaignActive) return;

        event.stopPropagation();
        setSelectedMarketId(params.data.marketId);
        
    };

    const handleShowComposeEmailForm = () => {
        setSelectedMarketId(null);
        setShowComposeEmailForm(true);
        setShowNotifyAllMarkets(false);
    };

    // Op data grid settings
    const statusColumnValueFormatter = (params) => {
        const marketStatus = {
          N: 'New',
          A: 'Avails',
          D: 'Draft',
          F: 'Final',
        };
    
        return marketStatus[params.value];
    };

    const headers = ['marketName', 'status', 'availsPending'];

    const columnDefinitions = React.useMemo(() => [
        { headerName: 'MARKET', field: 'marketName' },
        {
            headerName: 'STATUS',
            field: 'status',
            filterParams: { valueFormatter: statusColumnValueFormatter },
            valueFormatter: statusColumnValueFormatter,
        },
        { headerName: 'AVAILS', field: 'availsPending' },
        {
            field: 'action',
            cellDataType: 'text',
            headerName: ' ',
            width: 80,
            cellRenderer: (params) => {
                return (
                <img
                    src={notifyStationsIcon}
                    className={`notify-stations-icon ${!isCampaignActive ? 'disabled' : ''}`}
                    title="Notify Stations"
                    alt="notify-stations"
                    onClick={(event) => handleGetStations(event, params)}
                />
                )
            },      
        },
    ], [handleGetStations]);

    React.useEffect(() => {
        handleGetMarkets();
    }, []);

    return (
        <>
            {isFetchingMarkets ? (
                <div className="form">
                    <BootstrapSpinner />
                </div>
            ) : (
                <>
                    <div className={'d-flex justify-content-center w-100'}>
                        <div style={{ marginTop: '68px', width: '75%' }}>
                            <OpDataGrid
                                columns={columnDefinitions}
                                customVerbiage={'No Markets Found'}
                                defaultSort={{ field: 'marketName', sort: 'asc' }}
                                gridHeightBuffer={412}
                                gridName={'mp-campaign-form-notification'}
                                resizable={true}
                                rows={markets}
                                sharedColumnProperties={{
                                    filter: { fields: headers, value: true },
                                    flex: { fields: headers, value: 1 },
                                    sortable: { fields: headers, value: true },
                                }}
                                showAlternativeRowHighlight={true}
                                suppressRowClickSelection={true}
                            />
                        </div>
                    </div>

                    <div
                        className="d-flex justify-content-end gap-4"
                        style={{ paddingRight: '185px', marginTop: '56px', marginBottom: '32px' }}
                    >
                        {!newCampaign && (
                            <Button defaultBtn onClick={handleCloseForm} text={'Close'} />
                        )}
                        <Button
                            text={'Notify All Stations'}
                            onClick={() => setShowNotifyAllMarkets(true)}
                            disabled={!isCampaignActive}
                        />
                        {newCampaign && (
                            <Button onClick={handleCloseForm} text="Done" />
                        )}
                    </div>
                </>
            )}

            {selectedMarketId && (
                <NotifySelectedMarketModal
                    onHide={() => setSelectedMarketId(null)}
                    onSelectContacts={setSelectedContacts}
                    selectedCampaign={selectedCampaign}
                    selectedMarketId={selectedMarketId}
                    setShowComposeEmailForm={handleShowComposeEmailForm}
                />
            )}

            {showNotifyAllMarketsForm && (
                <NotifyAllMarketsModal
                    onHide={() => setShowNotifyAllMarkets(false)}
                    onSelectContacts={setSelectedContacts}
                    selectedCampaign={selectedCampaign}
                    setShowComposeEmailForm={handleShowComposeEmailForm}
                />
            )}

            {showComposeEmailForm && (
                <ComposeEmailForm
                    onHide={setShowComposeEmailForm}
                    selectedCampaign={selectedCampaign}
                    selectedContacts={selectedContacts}
                    setShowSuccessfullyNotifiedModal={setShowSuccessfullyNotifiedModal}
                />
            )}

            {showSuccessfullyNotifiedModal && (
                <SuccessfullyNotifiedModal
                    onHide={() => setShowSuccessfullyNotifiedModal(false)}
                    selectedContacts={selectedContacts}
                />
            )}
        </>
    );
};

export default NotificationsForm;